import styled from 'styled-components';

const PageContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const RootButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(2)};
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const InProgressDateText = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
`;

interface DueProps {
  $overdue: boolean;
}

const DueDateText = styled.span<DueProps>`
  color: ${({ theme, $overdue }) => ($overdue ? theme.palette.error.main : 'inherit')};
  font-weight: ${({ $overdue }) => ($overdue ? 'bold' : 'inherit')};
`;

export { RootButtonsContainer,
  InProgressDateText,
  DueDateText,
  PageContainer,
  ContentContainer };
